import { ReactNode } from "react"
import style from './Card.module.scss'
import cx from 'classnames'


type CardProps = {
    title: string;
    description: string;
    content: ReactNode;
    titleAsHtml?: boolean;
    className?: string;
  }

export const Card = (props: CardProps) => {

    const title = props.titleAsHtml ? <CardTitle dangerouslySetInnerHTML={{__html: props.title}} /> : <CardTitle>{props.title}</CardTitle>

    return <CardContainer className={props.className}>
    <CardContent>{props.content}</CardContent>
    <CardDescriptionContainer>
      {title}
      <CardDescription>
        {props.description}
      </CardDescription>
    </CardDescriptionContainer>
  </CardContainer>
}

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const CardContainer = (props: DivProps) => {
    return <div {...props} className={cx(style['card-container'], props.className)} />
}
const CardContent = (props: DivProps) => {
    return <div {...props} className={style['card-content']} />
}
const CardDescriptionContainer = (props: DivProps) => {
    return <div {...props} className={style['card-description-container']} />
}

const CardTitle = (props: DivProps) => {
    return <div {...props} className={cx(style['card-title'], 'title')} />
}

type PProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>
const CardDescription = (props: PProps) => {
    return <p {...props} className={cx(style['card-description'], 'description')} />
}